export default __webpack_public_path__ + "1a9eccecd2601f5c7ff3d4801f48800e.svg";